import { Component, ViewChild } from '@angular/core';

import { HtmlEditorService, ImageService, LinkService, RichTextEditorComponent, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';

import { FieldMetadata, FieldWidthEnum, ViewMetadata } from '../../../cer/cer-data/cer-data-types';
import { UiActionTypeEnum, UiCommandEvent, UiCommandSourceEnum } from '@ui/cer-ui-types';
import { CerFormComponent } from '../../../cer/cer-form/cer-form.component';
import { CerFormPanesSettings } from '@form/cer-form-panes/cer-form-panes.service';
import { CerGridComponent } from 'src/cer/cer-grid/cer-grid.component';

@Component({
  selector: 'mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.css'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]

})
export class MailTemplateComponent {

  protected panesMasterDetail: CerFormPanesSettings = {
    main: { visible: 'show', size: '70%' },
    right: { visible: 'show', size: '30%' },
    orientationPrimary: 'horizontal'
  };

  form: CerFormComponent;
  @ViewChild('form', { static: false }) set formContent(content: CerFormComponent) {
    if (content && !this.form) {
      this.form = content;
      this.form.commmand.subscribe(e => this.onCommand(e));
    }
  }

  grid: CerGridComponent;
  @ViewChild('mainGrid', { static: false }) set gridContent(content: CerGridComponent) {
    if (content && !this.grid) {
      this.grid = content;
      this.grid.commmand.subscribe(e => this.onCommand(e));
    }
  }

  // View
  public viewMetadata: ViewMetadata = {
    name: 'mailTemplates', dataApiName: 'MailTemplate', text: 'Mail skabeloner',
    primaryKey: 'id', titleFields: ['name'], allowEdit: true, allowCreate: true, allowDelete: true, baseFields: ['history']
  };
  // Fields
  public fieldMetadata: FieldMetadata[] =
    [{ name: 'id', text: 'Id', tooltipText: 'Unik nøgle for skabelonen', allowEdit: false, visible: false, widthType: FieldWidthEnum.XS },
    { name: 'name', text: 'Navn', tooltipText: 'Navn', widthType: FieldWidthEnum.M, orderBy: 'Ascending' },
    { name: 'channel', text: 'Kanal', tooltipText: 'Hvilken kanal afsendes mail med', foreignKeyTableName: 'MailChannel' },
    { name: 'fromEmail', text: 'Fra e-mail', tooltipText: 'Afsender e-mail adresser', widthType: FieldWidthEnum.M, orderBy: 'Ascending' },
    { name: 'body', text: 'Indhold', tooltipText: 'E-mail indhold', widthType: FieldWidthEnum.M, visible: false }
    ];

  // Rich text
  public tools: object = {
    type: 'Expand',
    items: ['FullScreen', '|', 'Bold', 'Italic', 'Underline', 'StrikeThrough',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
      'Outdent', 'Indent', '|',
      'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
      'SourceCode', '|', 'Undo', 'Redo']
  };
  public richText: RichTextEditorComponent = null;
  @ViewChild(RichTextEditorComponent, { static: false }) set setViewChildRichText(richText: RichTextEditorComponent) {
    this.richText = richText;
  }

  constructor() {
  }

  // Commands
  public onCommand(event: UiCommandEvent) {
    switch (event.source) {
      case UiCommandSourceEnum.DesignChange:
        this.richTextReflow();
        break;
      case UiCommandSourceEnum.ActionBegin:
        break;
      case UiCommandSourceEnum.ActionComplete:
        switch(event.actionType)
        {
          case UiActionTypeEnum.RowSelect:
            this.richText.value = event.rowData?.body ;
            break;
        }
        break;
    }
  }

  private richTextReflow() {
    if (this.richText && this.richText.toolbarModule && this.richText.toolbarModule) {
      this.richText.toolbarModule.refreshToolbarOverflow();
    }
  }
}
